import { render, staticRenderFns } from "./ArticleCompanyEdit.vue?vue&type=template&id=a6d09aa6&"
import script from "./ArticleCompanyEdit.vue?vue&type=script&lang=js&"
export * from "./ArticleCompanyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports